import { useQuery } from "@tanstack/react-query";
import { getHeyApiRequestOptions } from "apiClients/base/heyApiRequestOptions";
import { isAdminOrSuperAdmin } from "utility/helper";
import type { DailyRevenueResponse, RevenueMarketFilter } from "../types";

async function fetchDailyRevenue(
  currency: RevenueMarketFilter,
): Promise<DailyRevenueResponse> {
  const options = getHeyApiRequestOptions();
  const auth = options.auth?.();
  const params = new URLSearchParams();
  if (currency) {
    params.set("currency", currency);
  }

  const query = params.toString();
  const response = await fetch(
    `${options.baseUrl}/api/statistics/revenue/daily${query ? `?${query}` : ""}`,
    {
      headers: {
        Accept: "application/json",
        ...(auth ? { Authorization: auth } : {}),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to load daily revenue (${response.status})`);
  }

  return (await response.json()) as DailyRevenueResponse;
}

export function useDailyRevenueQuery(currency: RevenueMarketFilter = null) {
  return useQuery({
    queryKey: ["dashboard-daily-revenue", currency ?? "all"],
    queryFn: () => fetchDailyRevenue(currency),
    enabled: isAdminOrSuperAdmin(),
  });
}
